import { detectCardType, CARD_BRAND_LABELS } from '../../utils/cardBrand';

const BRAND_LABELS = CARD_BRAND_LABELS;

function AmexIcon() {
  return (
    <svg className="card-brand-icon card-brand-icon--amex" viewBox="0 0 48 32" aria-hidden>
      <rect width="48" height="32" rx="4" fill="#2E77BC" />
      <text
        x="24"
        y="20"
        textAnchor="middle"
        fill="#fff"
        fontSize="9"
        fontWeight="700"
        fontFamily="Arial, Helvetica, sans-serif"
      >
        AMEX
      </text>
    </svg>
  );
}

function VisaIcon() {
  return (
    <svg className="card-brand-icon card-brand-icon--visa" viewBox="0 0 48 32" aria-hidden>
      <rect width="48" height="32" rx="4" fill="#1A1F71" />
      <text
        x="24"
        y="21"
        textAnchor="middle"
        fill="#F7B600"
        fontSize="11"
        fontWeight="700"
        fontStyle="italic"
        fontFamily="Arial, Helvetica, sans-serif"
      >
        VISA
      </text>
    </svg>
  );
}

function MastercardIcon() {
  return (
    <svg className="card-brand-icon card-brand-icon--mastercard" viewBox="0 0 48 32" aria-hidden>
      <rect width="48" height="32" rx="4" fill="#252525" />
      <circle cx="19" cy="16" r="8" fill="#EB001B" opacity="0.95" />
      <circle cx="29" cy="16" r="8" fill="#F79E1B" opacity="0.95" />
    </svg>
  );
}

function DiscoverIcon() {
  return (
    <svg className="card-brand-icon card-brand-icon--discover" viewBox="0 0 48 32" aria-hidden>
      <rect width="48" height="32" rx="4" fill="#F6F1E9" />
      <text
        x="24"
        y="20"
        textAnchor="middle"
        fill="#111"
        fontSize="8"
        fontWeight="700"
        fontFamily="Arial, Helvetica, sans-serif"
      >
        DISCOVER
      </text>
    </svg>
  );
}

function DefaultCardIcon() {
  return (
    <svg className="card-brand-icon card-brand-icon--default" viewBox="0 0 48 32" aria-hidden>
      <rect width="48" height="32" rx="4" fill="#f3f4f6" stroke="#d1d5db" strokeWidth="1" />
      <rect x="7" y="9" width="13" height="9" rx="1.5" fill="#d1d5db" />
      <rect x="7" y="22" width="18" height="2" rx="1" fill="#e5e7eb" />
      <rect x="28" y="22" width="13" height="2" rx="1" fill="#e5e7eb" />
    </svg>
  );
}

function GenericIcon() {
  return <DefaultCardIcon />;
}

export default function CardBrandIcon({ cardNumber, type, showDefault = false, className = '' }) {
  const brand = type || detectCardType(cardNumber);
  if (!brand || brand === 'unknown') {
    if (!showDefault) return null;
    return (
      <span
        className={`card-brand-icon-wrap card-brand-icon-wrap--default ${className}`.trim()}
        aria-hidden="true"
      >
        <DefaultCardIcon />
      </span>
    );
  }

  const icons = {
    amex: AmexIcon,
    visa: VisaIcon,
    mastercard: MastercardIcon,
    discover: DiscoverIcon,
    diners: GenericIcon,
    jcb: GenericIcon,
  };
  const Icon = icons[brand] || GenericIcon;
  const label = BRAND_LABELS[brand] || brand;

  return (
    <span className={`card-brand-icon-wrap ${className}`.trim()} title={label} aria-label={label}>
      <Icon />
    </span>
  );
}
